export default {
  register: { method: "post", url: "guiche/create" },
};
